import { render, staticRenderFns } from "./TeamsList.vue?vue&type=template&id=f5d30b1e&scoped=true"
import script from "./TeamsList.vue?vue&type=script&lang=js"
export * from "./TeamsList.vue?vue&type=script&lang=js"
import style0 from "./TeamsList.vue?vue&type=style&index=0&id=f5d30b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d30b1e",
  null
  
)

export default component.exports